import { useCallback } from 'react'

import { ERROR_REQUEST_RESET_PASSWORD_FAILURE, REQUEST_RESET_PASSWORD_SUCCESS } from '@/app/module/auth/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export type RequestResetPasswordValues = { email: string }

export const useRequestResetPassword = () => {
  const dispatch = useAppDispatch()
  const [requestResetPassword, res] = esApi.endpoints.authPasswordReset.useMutation()

  const requestReset = useCallback(
    async (values: RequestResetPasswordValues) => {
      try {
        await requestResetPassword({ body: { email: values.email } }).unwrap()
        dispatch(
          createNotification({
            'reset-password-success': { type: 'success', message: REQUEST_RESET_PASSWORD_SUCCESS },
          }),
        )
        return true
      } catch (error) {
        const errorMessage = getErrorMessage(error, ERROR_REQUEST_RESET_PASSWORD_FAILURE)
        dispatch(
          createNotification({
            'reset-password-error': { type: 'error', message: errorMessage },
          }),
        )
        return false
      }
    },
    [dispatch, requestResetPassword],
  )

  return [requestReset, res] as const
}
